import gql from 'graphql-tag'

export const ADD_SUBBRAND = gql`
  mutation addSubbrand($brandUuid: ID!, $name: String!) {
    addSubbrand(brandUuid: $brandUuid, name: $name) {
      id
      name
      state
    }
  }
`



// WEBPACK FOOTER //
// ./src/mutations/AddSubbrand.tsx